import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission, PermissionEntitiesNames } from '../../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      (!!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.REPORTS }) ||
        !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.REPORTS, permission: Permission.UPDATE })) &&
      !!context.userPermissions.hasAllowedPermissionToResource({
        resource: PermissionEntitiesNames.ACCOUNT,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
